/** @format */

import { Col, Row } from 'antd';
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Service } from './services';
import { IMAGES } from '../../v2-config/constants/images.constant';
import { validateUrl } from './handle/validate-url.handle';
import './style.scss';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';

export default function Footer(props) {
	const [date] = useState(new Date().getFullYear());
	const [data, setData] = useState(null);
	const [pharamcyInfo, setPharmacyInfo] = useState(null);
	const [isLoading, setLoading] = useState(true);

	const [modules, setModules] = useState([]);
	const [loadingModules, setLoadingModules] = useState(true);

	useEffect(() => {
		new Service()
			.getModulesByTemplate('home', 'ecommerce', Enviroment.ROOT_PHARMACY)
			.then((res) => {
				setModules(res.data);
				setLoadingModules(false);
			})
			.catch((err) => {
				console.error('Error cargando módulos:', err);
				setLoadingModules(false);
			});
	}, []);

	const pharmacyFooter = modules.find((m) => m.location === 'footer-logo');
	const footerUrl = pharmacyFooter?.image;

	useEffect(() => {
		new Service()
			.getPharmacy()
			.then((response) => {
				if (response?.data[0]) {
					console.log('response', response);
					setPharmacyInfo(response.data[0]);
					localStorage.setItem('pharmacyInfo', JSON.stringify(response?.data[0]));
				}
			})
			.catch((error) => {
				console.log('error', error);
			});
		new Service()
			.getFooter()
			.then((response) => {
				console.log('resposne', response);
				setData(response.data[0]);
				setLoading(false);
			})
			.catch((error) => {
				console.log(error);
			});
	}, []);
	console.log('pharmacyInfo', pharamcyInfo);

	if (isLoading) return null;
	return (
		<>
			<Row className="footer-content" justify="center">
				<Col span={22} className="container">
					{loadingModules ? (
						<></>
					) : (
						<Link to={'/'} className={'text-link logo-link'}>
							<img src={footerUrl ? footerUrl : IMAGES.FILE_NOT_AVAILABLE} alt="logo" className="logo" height={42} />
						</Link>
					)}
					<Row justify="center">
						<Col md={6} xs={24} className="footer-module">
							<h3 className="own-medium h3.md">Nosotros</h3>
							<Link to={'/'} className="no-hover">
								{data?.name_pharmacy}
							</Link>
							<br></br>
							<Link to={'/'} className="no-hover">
								{data?.rut}
							</Link>
							<br></br>
							<a href={`tel:${pharamcyInfo?.phone}`} className="no-hover">
								{pharamcyInfo?.phone}
							</a>
							<br></br>
							<Link to={'/'} className="no-hover">
								{data?.address}
							</Link>
							<br></br>
							<a href={`mailto::${pharamcyInfo?.email}`} className={'text-link'}>
								{pharamcyInfo?.email}
							</a>
						</Col>
						<Col md={6} xs={24} className="footer-module">
							<h3 className="own-medium h3.md">Legales</h3>
							<Link to={'/claims'} className={'text-link'}>
								Reclamos y Sugerencias
							</Link>
							<br></br>
							<Link to="/" onClick={() => window.open(validateUrl(data?.faq))} className={'text-link'}>
								Políticas y Devoluciones
							</Link>
							<br></br>
							<Link to="/" onClick={() => window.open(validateUrl(data?.shortage_letter))} className={'text-link'}>
								Carta de desabastecimiento
							</Link>
							<br></br>

							<Link to="/" onClick={() => window.open(validateUrl(data?.electronic_sales_resolution))} className={'text-link'}>
								Resolución Venta Electrónica
							</Link>
							<br></br>
							<Link
								to="/"
								onClick={() => window.open('https://storage.googleapis.com/tirx-resources-develop/b22b7b71-1c6f-4e99-ab3c-9ac328bf5458.webp')}
								className={'text-link'}
							>
								Uso Racional de Medicamentos
							</Link>
						</Col>
						<Col md={6} xs={24} className="footer-module">
							<h3 className="own-medium h3.md">Reglamentación</h3>
							<Link to="/" onClick={() => window.open('https://www.bcn.cl/leychile/navegar?idNorma=13613')} className={'text-link'}>
								Reglamento de Farmacia
							</Link>
							<br></br>
							<Link to="/" onClick={() => window.open('https://www.bcn.cl/leychile/navegar?idNorma=1026879')} className={'text-link'}>
								Reglamento de Productos Farmaceúticos
							</Link>
							<br></br>
							<Link to="/" onClick={() => window.open('https://www.ispch.cl/anamed/farmacovigilancia/nram/')} className={'text-link'}>
								Formulario RAM
							</Link>
						</Col>
						<Col md={6} xs={24} className="footer-module">
							<h3 className="own-medium h3.md">Emergencias toxicológicas</h3>
							<Link to={'/'} className="no-hover">
								Emergencias Toxicológicas
							</Link>
							<br></br>
							<a href={`tel:+56226353800`} className="no-hover">
								Toxicológicas +562-2635-3800
							</a>
							<br></br>
							<a href={`tel:+56222473600`} className="no-hover">
								Químicas +562-2247-3600
							</a>
							<br></br>
							<a href={`tel:+6003607777`} className="no-hover">
								Salud Responde: 600 360 7777
							</a>
						</Col>
					</Row>
				</Col>
				<Col span={24}>
					<Row justify="center" className="copyright">
						<p>Copyright TIRX 2023 - {date}</p>
					</Row>
				</Col>
			</Row>
		</>
	);
}
